/**
 * TokenPrice — унифицированное отображение стоимости операции в токенах.
 *
 * Везде где показываем цену (кнопки экшенов, submit'ы, pill'ы в списках) —
 * используем этот компонент чтобы визуал был одинаковый: число + иконка-
 * монета (Coin).
 *
 * Иконка: `icons/Coin` — тот же компонент что использует SunoLyricsButton,
 * фирменный градиент проекта.
 */
import { Coin } from '../icons/Coin'

interface Props {
	/** Цена в токенах. Если null/undefined — не рендерим ничего. */
	value: number | null | undefined
	/** Размер иконки в px. По умолчанию 11 — компактно под текст. */
	iconSize?: number
	/** Добавить пояснение «токенов» тулипом/aria-label. */
	ariaLabel?: boolean
	/** Дополнительный className для span'а (для размещения в layout'ах). */
	className?: string
}

export default function TokenPrice({
	value,
	iconSize = 11,
	ariaLabel = true,
	className,
}: Props) {
	if (value == null) return null
	const label = ariaLabel ? `${value} ${pluralizeTokens(value)}` : undefined
	return (
		<span
			className={'token-price' + (className ? ' ' + className : '')}
			aria-label={label}
			title={label}
		>
			<span className="token-price__value">{value}</span>
			<Coin size={iconSize} className="token-price__icon" />
		</span>
	)
}

/** «токен / токена / токенов» — единое имя валюты для подписей цены. */
export function pluralizeTokens(n: number): string {
	const mod10 = n % 10
	const mod100 = n % 100
	if (mod10 === 1 && mod100 !== 11) return 'токен'
	if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'токена'
	return 'токенов'
}
